@if (message) {
  <p class="error">{{ message }}</p>
}
